import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { theme } from 'assets/styles/theme';
import { RedTextButton } from 'components/buttons/RedTextButton';
import Share, { ShareProps } from 'features/share/Share';

import { useCampaignPopup } from './useCampaignPopup';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 70px;

  ${theme.mq.phone} {
    padding: 0;
  }
`;

const PostAnotherButton = styled(RedTextButton)`
  width: 100%;
  border: 1px solid ${theme.color.red};
`;

const GoToCampaign = styled(RedTextButton)`
  width: 100%;
  font-size: 14px;
`;

interface Props extends ShareProps {
  onGoToCampaign: () => void;
}

const ShareCampaignPopup = (props: Props) => {
  const { t } = useTranslation('addCampaign');
  const { showAddCampaignPopup } = useCampaignPopup();

  return (
    <Container data-testid={'share-campaign-popup'}>
      <Share {...props} />
      <PostAnotherButton onClick={() => showAddCampaignPopup()}>{t('share.post-another')}</PostAnotherButton>
      <GoToCampaign onClick={props.onGoToCampaign}>{t('share.go-to-campaign')}</GoToCampaign>
    </Container>
  );
};

export default ShareCampaignPopup;
